import { Link } from "react-router-dom";
import { Mail, MapPin, Phone, Instagram } from "lucide-react";
import { SERVICES } from "@/components/Services";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#0A192F] text-white pt-16 pb-8"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <Link to="/" className="flex items-center gap-3">
              <img
                src="/logo.png"
                alt="SHUNYA CDC"
                className="h-12 w-12 object-contain rounded-md bg-white p-1"
              />
              <div>
                <div className="font-heading text-xl font-bold tracking-tight">
                  SHUNYA CDC
                </div>
                <div className="text-[11px] uppercase tracking-[0.24em] text-white/60">
                  Where Everything Begins
                </div>
              </div>
            </Link>
            <p className="mt-5 text-white/70 max-w-md leading-relaxed">
              A modern, clinical child development center offering
              evidence-based pediatric therapies — helping every child grow
              with confidence.
            </p>
            <div className="mt-6 space-y-2 text-sm text-white/80">
              <div className="flex items-start gap-3">
                <MapPin className="h-4 w-4 mt-0.5 text-[#7FB4FF]" />
                Kanwal Plaza, Ground Floor, Opp. DMart, Kardhani, Kalwar Road, Jaipur 302012
              </div>
              <div className="flex items-center gap-3">
                <Phone className="h-4 w-4 text-[#7FB4FF]" />
                +91 9251800011 · +91 9214099331
              </div>
              <div className="flex items-center gap-3">
                <Mail className="h-4 w-4 text-[#7FB4FF]" />
                shunyacdc@gmail.com
              </div>
              <a
                href="https://www.instagram.com/shunyacdc/"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-instagram-link"
                className="inline-flex items-center gap-3 text-sm text-white/80 hover:text-white transition-colors"
              >
                <Instagram className="h-4 w-4 text-[#7FB4FF]" />
                @shunyacdc
              </a>
            </div>
          </div>

          <div className="md:col-span-4">
            <div className="text-[11px] uppercase tracking-[0.22em] text-white/60">
              Services
            </div>
            <ul className="mt-4 space-y-2">
              {SERVICES.map((s) => (
                <li key={s.key}>
                  <a
                    href="#services"
                    data-testid={`footer-service-${s.key}`}
                    className="text-sm text-white/80 hover:text-white transition-colors"
                  >
                    {s.title}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="text-[11px] uppercase tracking-[0.22em] text-white/60">
              Explore
            </div>
            <ul className="mt-4 space-y-2">
              {[
                ["About", "#about"],
                ["Process", "#process"],
                ["FAQ", "#faq"],
                ["Contact", "#contact"],
              ].map(([label, href]) => (
                <li key={href}>
                  <a
                    href={href}
                    data-testid={`footer-link-${label.toLowerCase()}`}
                    className="text-sm text-white/80 hover:text-white transition-colors"
                  >
                    {label}
                  </a>
                </li>
              ))}
              <li>
                <Link
                  to="/book"
                  data-testid="footer-book-link"
                  className="text-sm text-white/80 hover:text-white transition-colors"
                >
                  Book Consultation
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-white/60">
          <div>© {new Date().getFullYear()} SHUNYA CDC, Jaipur. All rights reserved.</div>
          <div>Made with care for every child.</div>
        </div>
      </div>
    </footer>
  );
}
